import React from 'react';
import { Button, Icon, IconButton } from 'components/ui';
import AISvg from 'components/shared/svg/AISvg';

const EditControls = ({
  editMode,
  toggleEditMode,
  updateHandler,
  generateGPTResponse,
  readOnly,
  onCancelClick,
}) => {
  if (editMode) {
    return (
      <div className="LessonRecap-editControls EditableModule-editActions border-none">
        <Button
          readOnly={readOnly}
          onClick={onCancelClick}
          className="EditableModule-action"
          aria-label={t('common.cancel')}
        >
          {t('common.cancel')}
        </Button>
        <Button
          className="EditableModule-action"
          readOnly={readOnly}
          onClick={generateGPTResponse}
        >
          <span className="d-f ai-c">
            <AISvg />
            {t('lessons.recap.generate')}
          </span>
        </Button>
        <Button
          className="EditableModule-action"
          aria-label={t('common.save')}
          readOnly={readOnly}
          customColor
          onClick={updateHandler}
        >
          {t('common.save')}
        </Button>
      </div>
    );
  }

  if (!editMode) {
    return (
      <span className="float-right pt-6">
        <IconButton onClick={toggleEditMode} aria-label={t('common.edit')}>
          <Icon name="edit" />
        </IconButton>
      </span>
    );
  }
  return null;
};

export default EditControls;
